export default __webpack_public_path__ + "static/media/62.4427f86a.jpg";